import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { updateProfile } from "firebase/auth";

export function ProfileSettings() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [displayName, setDisplayName] = useState(user?.displayName || "");
  const [email] = useState(user?.email || "");

  const handleSaveProfile = async () => {
    if (!user) return;

    try {
      setIsLoading(true);
      
      // Update Firebase Auth profile
      await updateProfile(user, {
        displayName: displayName
      });

      // Update Firestore user document if it exists
      try {
        await updateDoc(doc(db, "users", user.uid), {
          displayName: displayName,
          updatedAt: new Date()
        });
      } catch (error) {
        // Document might not exist, which is fine
        console.log("User document not found in Firestore, skipping update");
      }

      toast({
        title: "Profile updated",
        description: "Your profile has been successfully updated.",
      });
    } catch (error) {
      console.error("Error updating profile:", error);
      toast({
        title: "Error",
        description: "Failed to update profile. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4">
        <div className="grid gap-2">
          <Label htmlFor="displayName">Display Name</Label>
          <Input
            id="displayName"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Enter your display name"
          />
        </div>
        
        <div className="grid gap-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            value={email}
            disabled
            className="bg-muted"
          />
          <p className="text-sm text-muted-foreground">
            Email cannot be changed from here
          </p>
        </div>
      </div>
      
      <Button 
        onClick={handleSaveProfile} 
        disabled={isLoading || !displayName.trim()}
        
      >
        {isLoading ? "Saving..." : "Save Profile"}
      </Button>
    </div>
  );
}